import { FC, useCallback } from 'react';
import { useSnapshot } from 'valtio';
import { resendInvitation } from '../actions/resend-invitation-actions';
import { revokeInvitation } from '../actions/revoke-invitation-actions';
import ResendInvitationModal from '../components/ResendInvitationModal';
import { closeResendInvitationModal } from '../store-actions/resend-invitation-store-actions';
import ResendInvitationStore from '../stores/resend-invitation-store';
import RevokeInvitationStore from '../stores/revoke-invitation-store';

const ResendInvitationContainer: FC<React.PropsWithChildren<unknown>> = () => {
  const {
    isModalVisible,
    isLoading: isLoadingResend,
    selectedRevokedInvitedMember,
  } = useSnapshot(ResendInvitationStore);

  const { isLoading: isLoadingRevoke } = useSnapshot(RevokeInvitationStore);

  const onResend = useCallback(async () => {
    if (!selectedRevokedInvitedMember) {
      return;
    }
    await resendInvitation(selectedRevokedInvitedMember.id);
  }, [selectedRevokedInvitedMember]);

  const onRevoke = useCallback(async () => {
    if (!selectedRevokedInvitedMember) {
      return;
    }
    await revokeInvitation(selectedRevokedInvitedMember.id);
  }, [selectedRevokedInvitedMember]);

  if (!isModalVisible) {
    return null;
  }

  return (
    <ResendInvitationModal
      open={isModalVisible}
      onClose={closeResendInvitationModal}
      pendingInvitationMember={selectedRevokedInvitedMember}
      onResend={onResend}
      onRevoke={onRevoke}
      isLoadingResend={isLoadingResend}
      isLoadingRevoke={isLoadingRevoke}
    />
  );
};

export default ResendInvitationContainer;
